import { useCallback, useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { initialPatch, demoFrame } from "@/lib/patchState";

const EMPTY = [{ path: "brak plików w manifeście", size: 1 }];

export function useDemoPatch(setState) {
  const timer = useRef(null);
  useEffect(() => () => clearInterval(timer.current), []);

  return useCallback(async () => {
    clearInterval(timer.current);
    setState({ ...initialPatch, phase: "checking", text: "Pobieranie listy plików..." });
    let files;
    try {
      const { data } = await api.get("/patch/manifest");
      files = data.files.length ? data.files : EMPTY;
    } catch {
      setState((s) => ({ ...s, phase: "error", error: "Nie udało się pobrać listy plików" }));
      return;
    }
    let index = 0;
    let percent = 0;
    timer.current = setInterval(() => {
      percent += 20;
      if (percent > 100) { percent = 0; index += 1; }
      if (index < files.length) {
        setState((s) => ({ ...s, ...demoFrame(files, index, percent) }));
        return;
      }
      clearInterval(timer.current);
      setState((s) => ({ ...s, phase: "done", filePercent: 100, totalPercent: 100, done: files.length, text: "Klient jest aktualny" }));
    }, 120);
  }, [setState]);
}
